"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateDurationInFrames = void 0;

var validateDurationInFrames = function validateDurationInFrames(durationInFrames, component) {
  if (typeof durationInFrames !== 'number') {
    throw new Error("The \"durationInFrames\" prop ".concat(component, " must be a number, but you passed a value of type ").concat(typeof durationInFrames));
  }

  if (durationInFrames <= 0) {
    throw new TypeError("The \"durationInFrames\" prop ".concat(component, " must be positive, but got ").concat(durationInFrames, "."));
  }

  if (durationInFrames % 1 !== 0) {
    throw new TypeError("The \"durationInFrames\" prop ".concat(component, " must be an integer, but got ").concat(durationInFrames, "."));
  }
};

exports.validateDurationInFrames = validateDurationInFrames;